import {removeLengthUnitFromCssVar} from "../utilities/helper-function";

class Form {
    constructor(element) {
        this.form = element;
        this.isFormDesktopHorizontal = element.classList.contains('form--desktop-horizontal');

        if (this.isFormDesktopHorizontal) {
            if(this.form.classList.contains('form--bg-navy-main')) {
                return;
            }

            this.footerPanel = this.form.querySelector('.form__footer-panel');
            this.formGroups = this.form.querySelectorAll('.form__group');
            this.lastFormItem = this.formGroups[this.formGroups.length - 1];

            this.rootStyles = getComputedStyle(document.documentElement);
            this.paddingValue = removeLengthUnitFromCssVar(this.rootStyles.getPropertyValue('--form-control-content-padding-x').trim());

            this.adjustFooterPanelPosition();
            window.addEventListener('resize', this.adjustFooterPanelPosition.bind(this));
        }
    }

    updateMeasurements() {
        const contentInner = this.lastFormItem.querySelector('.form__control-content-inner');
        if (contentInner) {
            const formContentHeight = contentInner.scrollHeight;
            this.lastFormItemCorrectHeight = this.paddingValue * 2 + formContentHeight;
        } else {
            this.lastFormItemCorrectHeight = 0;
        }
    }

    adjustFooterPanelPosition() {
        if (window.innerWidth >= 1200) {
            this.updateMeasurements();
            const actualHeight = this.lastFormItem.scrollHeight;
            const offset = actualHeight - this.lastFormItemCorrectHeight;
            this.footerPanel.style.marginTop = `${-offset}px`;
        } else {
            this.footerPanel.removeAttribute('style');
        }

    }
}

export default Form;